import { IconButton } from '@components/iconButton';
import { Tooltip } from '@components/tooltip/Tooltip';
import * as SVG from '@assets/svgs';
import { ITooltipIcon } from './Tooltip.types';

export const TooltipRemove = ({ onClick }: ITooltipIcon) => (
  <Tooltip placement='top' title='Remove'>
    <IconButton variant='rounded' size='small' onClick={onClick}>
      <SVG.TrashAlt width='12px' height='13px' />
    </IconButton>
  </Tooltip>
);
